<template>
	<div>
		<p>
			{{
				selectRandom([
					"Eligible participants will be randomly assigned",
					"The eligible participants will be randomly assigned",
					"Participants will be randomly assigned",
					"We are planning to randomly assign participants"
				])
			}}
			{{
				$tera.project.TrialWizard.ratioRandomization
					? joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.ratioRandomization)
				)
					: "BLANK"
			}}
			{{ selectRandom(["to the"]) }}
			{{ interventionAndControl }},
			{{ selectRandom(["using"]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.sequenceGen)
				)
			}}.
			{{
				selectRandom([
					"Allocation of concealment will be achieved by",
					" Blinding will be achieved by",
					"Blinding of the allocation of participants will be achieved by",
					"We are achieveing allocation of consealment by"
				])
			}}
			{{
				$tera.project.TrialWizard.concealment
					? $tera.project.TrialWizard.concealment
					: "BLANK"
			}}.
		</p>
		<p>
			{{
				selectRandom([
					"The mechanism for implementing the allocation sequence involved"
				])
			}}
			{{
				joinArrayWithAnd(formatSelectMulti($tera.project.TrialWizard.mechanism))
			}}
		</p>
		<p>
			{{
				selectRandom([
					"Steps to conceal the sequence until interventions are assigned included"
				])
			}}
			{{
				$tera.project.TrialWizard.concealSteps
					? $tera.project.TrialWizard.concealSteps
					: "BLANK"
			}}.
		</p>
		<p>
			{{
				selectRandom([
					"Treatment assignment will be blinded for",
					"Blinding of treatment assignment for",
					"We are planning treatment assignment blinding",
					"The method of treatment blinding"
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.blindedPeople)
				)
			}}
			{{
				selectRandom([
					"throughout the duration of the study.",
					"during the duration of the study.",
					"throughout the time of the study.",
					"throughout the study."
				])
			}}
			{{
				selectRandom([
					"Blinding was achieved by",
					"We achieved blinding by",
					"Blinding was accomplished with",
					"We are blinding by "
				])
			}}
			{{
				$tera.project.TrialWizard.blindedMethod
					? $tera.project.TrialWizard.blindedMethod
					: "BLANK"
			}}.
			{{
				selectRandom([
					"Participants will be unblinded for the following reasons:",
					"Unblinding will be for the following reasons:",
					"We will unblind participants when they are",
					"Unblinding will be when participants "
				])
			}}
			{{
				joinArrayWithOr(formatSelectMulti($tera.project.TrialWizard.unblinding))
			}}.
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";

export default {
	name: "OutputAssignmentOfInterventions",
	mixins: [OutputMixin],
	computed: {
		interventionAndControl() {
			if (
				(!this.$tera.project.TrialWizard.interventions ||
					this.$tera.project.TrialWizard.interventions.length < 1) &&
				(!this.$tera.project.TrialWizard.control ||
					this.$tera.project.TrialWizard.control.length < 1)
			) {
				return "BLANK";
			}
			let array = this.mapGroupNames(
				this.$tera.project.TrialWizard.interventions
			).concat(this.mapGroupNames(this.$tera.project.TrialWizard.control));
			return this.joinArrayWithAnd(array);
		}
	},
	methods: {
		mapGroupNames(groups) {
			if (!groups || groups.length < 1) {
				return [];
			}
			return groups.map(group => `${group.name} group`);
		}
	}
};
</script>
